import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { WardsComponent } from './wards.component'
import { CreateWardComponent } from './create-ward/create-ward.component'
import { UpdateWardComponent } from './update-ward/update-ward.component'
import { wardsRoutes } from './wards.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '@shared/shared.module'

@NgModule({
  declarations: [WardsComponent, CreateWardComponent, UpdateWardComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(wardsRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
  ],
  exports: [WardsComponent, CreateWardComponent, UpdateWardComponent],
})
export class WardsModule {}
